import { useExtractDocs } from "context/ExtractDocsContext";
import { Banner } from "ds/ui";
import { useTranslations } from "translations";

export function ExtractServiceUnavailableBanner({
  className,
}: {
  className?: string;
}) {
  const translations = useTranslations();
  const { extractOcrStatus } = useExtractDocs();

  if (!extractOcrStatus.error) {
    return null;
  }

  return (
    <div className={className}>
      <Banner
        color="danger"
        data-testid="extract-service-unavailable-banner"
        heading={translations.extractDocs.extractBanner.serviceUnavailableTitle}
        message={
          translations.extractDocs.extractBanner.serviceUnavailableDescription
        }
      />
    </div>
  );
}
